"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IESApiClient = void 0;
/* eslint-disable camelcase */
const cross_fetch_1 = require("cross-fetch");
const client_1 = require("@apollo/client");
class IESApiClient {
    /**
     * Client Constructor
     *
     * @param uri which endpoint the request should be made to
     * @param credentials can either be client credentials (m2m) or a Jwt token
     * @param isFrontendClient adds extra functionality for react-hooks
     */
    constructor(uri, credentials, isFrontendClient) {
        this.uri = uri;
        this.credentials = credentials;
        this.client = this.createIesClient(this.uri, isFrontendClient !== null && isFrontendClient !== void 0 ? isFrontendClient : false);
        this.credentials = credentials;
    }
    /**
     * Used to perform a query
     *
     * @param document the gql document node
     * @param variables typed variables dependant on the Generic passed in as K
     *
     * @returns Generic T response
     */
    run(document, 
    // eslint-disable-next-line default-param-last
    variables = {}, 
    // eslint-disable-next-line default-param-last
    fetchPolicy = 'cache-first', userHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = userHeaders !== null && userHeaders !== void 0 ? userHeaders : (yield this.getAuthorizationHeader());
            let response;
            if (document.definitions.length > 1) {
                throw new Error('Please use one document per request');
            }
            if (document.definitions[0].kind === 'OperationDefinition') {
                switch (document.definitions[0].operation) {
                    case 'mutation':
                        response = yield this.client.mutate({
                            context: { headers },
                            mutation: document,
                            variables,
                        });
                        break;
                    case 'query':
                        response = yield this.client.query({
                            context: { headers },
                            query: document,
                            variables,
                            fetchPolicy,
                        });
                        break;
                    default:
                        throw new Error('Not valid document type');
                }
            }
            else {
                throw new Error('Operation document type does not match expected value');
            }
            return response;
        });
    }
    /**
     * Connects the client to the API and returns the authorization header
     *
     * @returns the authorization header for the API
     */
    getAuthorizationHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            let access_token;
            if (this.credentials.type === 'client') {
                const { auth0Domain, auth0Audience, clientId, clientSecret } = this.credentials;
                const response = yield (0, cross_fetch_1.fetch)(`${auth0Domain}/oauth/token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        audience: auth0Audience,
                        grant_type: 'client_credentials',
                        client_id: clientId,
                        client_secret: clientSecret,
                    }),
                }).then((data) => data.json());
                access_token = response.access_token;
            }
            else {
                access_token = this.credentials.token;
            }
            return { Authorization: `Bearer ${access_token}` };
        });
    }
    /** Creates the auth middle ware for to add authorisation header to calls */
    createAuthMiddleware() {
        /* eslint-disable @typescript-eslint/ban-ts-comment */
        // @ts-ignore this has been ignored because of a weird typing bug
        return new client_1.ApolloLink((operation, forward) => __awaiter(this, void 0, void 0, function* () {
            const authHeaders = yield this.getAuthorizationHeader();
            operation.setContext(({ headers = {} }) => ({
                headers: Object.assign(Object.assign({}, headers), authHeaders),
            }));
            return forward(operation);
        }));
    }
    /**
     * Create IES Client
     *
     * @param uri which endpoint to direct the client to
     * @param isFrontendClient determines if the client is used on the frontend
     * @returns an initialized client
     */
    createIesClient(uri, isFrontendClient) {
        const linkUrl = new client_1.HttpLink({ uri: `${uri}/graphql`, fetch: cross_fetch_1.fetch });
        const link = isFrontendClient ? (0, client_1.concat)(this.createAuthMiddleware(), linkUrl) : linkUrl;
        return new client_1.ApolloClient({
            link,
            cache: new client_1.InMemoryCache({
                addTypename: false,
            }),
        });
    }
}
exports.IESApiClient = IESApiClient;
